import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { NAV_LINKS, isNavLinkActive } from "@routes/navLinks";
import { useLanguage } from "@contexts/LanguageContext";
import useTranslations from "@hooks/useTranslations";
import { ICONS } from "@utils/icons";

const Header = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { lang, toggleLanguage } = useLanguage();
  const t = useTranslations();
  const location = useLocation();

  return (
    <div className="bostami-header-area mb-30 z-index-5">
      <div className="container">
        <div className="bostami-header-wrap">
          <div className="row align-items-center">
            <div className="col-6">
              <div className="bostami-header-logo" />
            </div>
            <div className="col-6">
              <div className="bostami-header-menu-btn text-right mb-0 d-flex justify-content-end align-items-center gap-2">
                <button
                  className="lang-toggle-btn"
                  onClick={toggleLanguage}
                  aria-label={t.a11y.switchLanguage}
                  title={t.a11y.switchLanguage}
                >
                  <i className={ICONS.language} />
                  <span>{lang === "fr" ? "EN" : "FR"}</span>
                </button>
                <button
                  className={`menu-btn d-lg-none ${isMobileMenuOpen ? "active" : ""}`}
                  aria-label={t.a11y.openMenu}
                  aria-expanded={isMobileMenuOpen}
                  onClick={() => setMobileMenuOpen((open) => !open)}
                >
                  <span />
                  <span />
                  <span />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/*
          Classe propre au projet : le template masque
          `.home-3 .bostami-main-menu-wrap` en dessous de 992 px, soit
          exactement la plage où le bouton burger s'affiche.
        */}
        {isMobileMenuOpen && (
          <nav className="mobile-nav d-lg-none">
            <ul>
              {NAV_LINKS.map((link) => (
                <li
                  key={link.path}
                  className={isNavLinkActive(link, location.pathname) ? "active" : ""}
                >
                  <NavLink to={link.path} onClick={() => setMobileMenuOpen(false)}>
                    <div className="d-flex gap-2">
                      <span>
                        <i className={link.icon} />
                      </span>
                      {t.nav[link.labelKey]}
                    </div>
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
        )}
      </div>
    </div>
  );
};

export default Header;
